export const fetcher = (key, body) =>{
    var token = localStorage.getItem('jwt')
	
	return fetch(
    `${process.env.REACT_APP_BACKEND_URL}${key}`,
    {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`
        }
    }).then(res => res.json())}